var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            size: "xl",
            title: "Details Kostennote",
            visible: _vm.isModalOpen,
          },
          on: { hide: _vm.reset, show: _vm.loadFee },
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center pt-1" },
                [_c("csp-loading-indicator")],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "b-card",
                    { staticClass: "mb-4 info-card" },
                    [
                      _c(
                        "b-row",
                        _vm._l(_vm.fee, function (value, key) {
                          return _c(
                            "b-col",
                            { key: key, attrs: { cols: "4" } },
                            [
                              _c("div", { staticClass: "info-card-element" }, [
                                _c("label", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.labels[key] || key) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.formatters[key]
                                          ? _vm.formatters[key](value)
                                          : value
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.payments.length > 0
                    ? _c("div", [
                        _c("hr"),
                        _vm._v(" "),
                        _c("h2", { staticClass: "mb-4" }, [
                          _vm._v(
                            "\n                    Zahlungen\n                "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.payments, function (payment) {
                    return _c(
                      "b-card",
                      { key: payment.id, staticClass: "info-card" },
                      [
                        payment.meta.permissions.canDelete
                          ? _c(
                              "b-button",
                              {
                                staticClass: "float-right",
                                attrs: { size: "sm", variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deletePayment(payment.id)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    Löschen\n                "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          _vm._l(payment.attributes, function (value, key) {
                            return _c(
                              "b-col",
                              { key: key, attrs: { cols: "4" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "info-card-element" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.labels[key] || key) +
                                          "\n                            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.formatters[key]
                                              ? _vm.formatters[key](value)
                                              : value
                                          ) +
                                          "\n                            "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("hr"),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }